<template>

    <div>
        <v-chip v-for="cat in categories" :key="cat.id"
                :color="color"
                text-color="white"
                label
                small
        >
            {{ shorten(cat.name) }}
        </v-chip>

    </div>
</template>

<script>

    import Store from '../store';

    export default {

        props: {
            selected: {
                required: false,
                type: Array,
                default: () => []
            },
            color: {
                required: false,
                type: String,
                default: 'primary'
            }
        },

        data() {
            return {
                categories: []
            }
        },

        computed: {
            categoriesLoaded() {
                return !this.$store.state.ProjectManager.categoriesCacheExpires;
            },
        },


        mounted() {
            this.$store.dispatch('ProjectManager/loadCategories')
                .then(() => {
                    this.prepareCategories();
                })
                .catch(() => {
                    Bus.$emit('server-error', {message: 'Categories could not be loaded'});
                });
        },

        methods: {
            prepareCategories() {
                this.selected.forEach((selectedId) => {
                    let found = this.$store.state.ProjectManager.categories.find((category) => {
                        return category.id === selectedId;
                    });

                    if (found) this.categories.push(found);
                });
            },

            shorten(categoryName) {
                  return categoryName.replace(/^(.{15}[^\s]*).*/, "$1");
            }
        },


        created() {
            if (!this.$store.state.ProjectManager) {
                this.$store.registerModule('ProjectManager', Store);
            }
        },

    }
</script>
